import React from 'react'

const SvgMicrophoneFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19 10a1 1 0 011 1c0 4.071-3.061 7.435-7 7.93V20h2a1 1 0 010 2H9a1 1 0 010-2h2v-1.07c-3.939-.495-7-3.859-7-7.93a1 1 0 112 0c0 3.308 2.691 6 6 6s6-2.692 6-6a1 1 0 011-1z'
    />
    <path d='M8 6a4 4 0 118 0v5a4 4 0 01-8 0V6z' />
  </svg>
)

export default SvgMicrophoneFilled
